<template>
  <form  class="margin-bottom-0" method="post" action="#">
    <div class="alert alert-danger" role="alert" v-show="message">
      {{ message }}
    </div>
    <div class="form-group m-b-15">
      <input type="text" class="form-control form-control-lg" name="email" id="email" v-model="email" placeholder="Enter your Email" :class="{'is-invalid': $v.email.$error}" @input="$v.email.$touch()" @keyup.enter="sendLogin()"/>
      <div v-if="$v.email.$error" class="invalid-feedback">Email is not valid.</div>
    </div>
    <div class="form-group m-b-5">
      <input type="password" class="form-control form-control-lg" name="password" id="password" v-model="password" placeholder="Enter your Password" :class="{'is-invalid': $v.password.$error}" @input="$v.password.$touch()" @keyup.enter="sendLogin()"/>
      <div v-if="$v.password.$error" class="invalid-feedback">Password is not valid.</div>
    </div>
    <div class="text-inverse pull-right m-b-15">
      <router-link :to="{ name: 'ForgotPassword', query: {redirect: $route.query}}" class="text-muted"><small>Forgot your password ?</small></router-link>
    </div>
    <div class="login-buttons">
      <button type="button" class="btn btn-primary get-started rounded-pill btn-block" style="font-size: 18px;" @click.stop.prevent="sendLogin()">Login</button>
    </div>
    <div class="m-t-20 m-b-40 p-b-40 text-inverse">
      Not a member yet? Click <router-link :to="{ name: 'Signup', query: {redirect: $route.query}}" class="text-theme">here</router-link> to register. <br>
    </div>
  </form>
</template>

<script>
import Vuex from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'Login',
  mixins: [validationMixin],
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  },
  data() {
    return {
      message: null,
      email: null,
      password: null
    }
  },
  methods: {
    ...Vuex.mapActions(['login', 'startLoading', 'endLoading', 'flash']),
    hideErrorMessage() {
      this.message = null
    },
    showErrorMessage(message) {
      this.message = message
    },
    sendLogin() {
      this.hideErrorMessage()
      if (!this.$v.email.$invalid && !this.$v.password.$invalid) {
        this.startLoading()
        this.login({ email: this.email, password: this.password })
          .then(() => {
            this.flash({
              message: 'You are successfully authenticated',
              type: 'success'
            })
            if (this.$route.query && this.$route.query.redirect) {
              this.$router.push({ path: this.$route.query.redirect })
            } else {
              this.$router.push('Home')
            }
          })
          .catch(err => {
            this.showErrorMessage(
              'Login/Password is not valid, please try again'
            )
            console.log('Failed when login', err)
          })
          .finally(() => this.endLoading())
      } else {
        this.showErrorMessage(
          'Login/Password must not be empty, please fill all fields and try again'
        )
      }
    }
  }
}
</script>
<style>
.btn-block {
  display: block;
  width: 100%;
  padding: 10px 16px;
}
.login.login-with-news-feed .login-content {
  width: auto;
  padding: 30px 60px;
}
.m-b-15 {
  margin-bottom: 15px !important;
}
.login .text-inverse {
  font-size: 12px;
}

.text-black,
.text-inverse {
  color: #2d353c !important;
}
.p-b-40 {
    padding-bottom: 40px!important;
}
.m-b-40 {
    margin-bottom: 40px!important;
}
.m-t-20 {
    margin-top: 20px!important;
}
.btn-lg {
    padding: 10px 16px;
    font-size: 18px;
    line-height: 1.3333333;
    border-radius: 6px;
}
.login .form-control.form-control-lg, .login .form-control.input-lg {
    font-size: 14px;
    height: 46px;
    padding: 10px 16px;
    line-height: 1.3333333;
    border-radius: 6px;
}

.text-grey-darker {
    color: #929ba1!important;
}
@media (max-width: 450px){
.login-content{
    position: relative;
}}
@media (max-width: 450px){
.login-header{
  position: relative;
    left: 20%;
}}
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/Login.vue